// extracted by mini-css-extract-plugin
export default {"navbar":"rIWQpt","navbtn":"gtDmDf","year":"tZEGGG","month":"vHcXpY","prev":"DBckTm","next":"aXgTgA","current-month-year":"LR_Vfg","currentMonthYear":"LR_Vfg"};